export default {
  /**
   * Gets items EXCLUDING expired
   * @param {*} state
   */
  getItems(state) {
    if (!Array.isArray(state.data.savedItems)) {
      return [];
    }
    return state.data.savedItems.filter((item) => {
      if (item.type === 'jobs' && item.expired === false) {
        return true;
      }

      if (
        item.type !== 'jobs'
        && item.type !== 'connect-shared'
      ) {
        return true;
      }

      return false;
    });
  },

  getItemsByType: (state) => ({ type, expired = null, registerInterest = null }) => {
    let returnItems = state.data.savedItems.filter((item) => {
      return item.type === type;
    });

    if (registerInterest !== null) {
      returnItems = returnItems.filter((item) => item.type === type && item.is_pre_reg_job === registerInterest);
    }

    if (expired !== null) {
      returnItems = returnItems.filter((item) => {
        return item.expired === expired;
      });
    }

    return returnItems;
  },

  getCountByType: (state, getters) => ({ type, expired = null, registerInterest = null }) => {
    return getters.getItemsByType({ type, expired, registerInterest }).length;
  },

  getItemSavedStatus: (state) => (payload) => {
    if (!payload.id || !payload.type) {
      return false;
    }

    const shortlisted = state.data.savedItems.find((item) => {
      return parseInt(item.id, 10) === parseInt(payload.id, 10) && item.type === payload.type;
    });

    return shortlisted !== undefined;
  },

  getItemCount(state) {
    return state.data.savedItems.filter((item) => {
      if (item.type === 'jobs' && item.expired === false) {
        return true;
      }
      if (
        item.type === 'conect-shared'
      ) {
        return false;
      }
      if (item.type !== 'jobs') {
        return true;
      }
      return false;
    }).length;
  },
  getItemById: (state) => (id) => {
    return state.data.savedItems.find((item) => item.id === id);
  },
};
